import { graphql } from "~/gql";

export const DELETE_DISBURSEMENT = graphql(/* GraphQL */ `
  mutation deleteDisbursement($disbursementId: Float!) {
    deleteDisbursement(disbursementId: $disbursementId) {
      disbursementId
    }
  }
`);
